import {
  Center,
  Flex,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Text,
} from '@chakra-ui/react'

import {
  Flex as DarkFlex,
  Text as DarkText,
  tokenPrefix,
  tokenVar,
} from '@hivewatch/dark'
import type { ColorScheme } from '@hivewatch/dark'

import { Button } from '@/components/ui'

import { GridModalHeader } from '../../components/GridModalHeader'
import { IncidentOptionI } from '../../types/types'

interface GridTestErrorCardIProps {
  colorScheme?: ColorScheme
  detail?: string
  isTimeout: boolean
  onClose: () => void
  onSelectAnotherIncident: () => void
  onRetry?: () => void
  selectedIncident: IncidentOptionI | null
}

export const GridTestErrorCard = ({
  colorScheme,
  detail,
  isTimeout,
  onClose,
  onSelectAnotherIncident,
  onRetry,
  selectedIncident,
}: GridTestErrorCardIProps) => {
  const errorDetail =
    detail ??
    (isTimeout
      ? 'The operation timed out. Please try again later.'
      : 'The grid analysis job could not be completed. Please try again.')

  if (colorScheme) {
    const tokenPathPrefix = tokenPrefix(colorScheme)

    return (
      <DarkFlex
        alignItems='center'
        flexDirection='column'
        justifyContent='center'
        minHeight='300px'
        textAlign='center'
      >
        <DarkText
          color={tokenVar(`colors.${tokenPathPrefix}status.error-text`)}
          fontSize='18px'
          fontWeight='bold'
          mb='8px'
        >
          {isTimeout ? 'The operation timed out' : 'Something went wrong'}
        </DarkText>
        <DarkText
          color={tokenVar(`colors.${tokenPathPrefix}text.secondary`)}
          fontSize='14px'
          maxWidth='400px'
        >
          {errorDetail}
        </DarkText>
      </DarkFlex>
    )
  }

  const content = (
    <Center flexDirection='column' minH='300px' textAlign='center'>
      <Text color='red.600' fontSize='lg' fontWeight='bold' mb={2}>
        {isTimeout ? 'The operation timed out' : 'Something went wrong'}
      </Text>
      <Text color='gray.600' fontSize='sm' maxW='400px'>
        {errorDetail}
      </Text>
    </Center>
  )

  return (
    <>
      <ModalHeader p={0} w='100%'>
        <GridModalHeader
          subtitle={
            selectedIncident
              ? `Results for ${selectedIncident.incidentId}`
              : 'Grid Testing Zone'
          }
          title={isTimeout ? 'Test Timed Out' : 'Test Failed'}
        />
      </ModalHeader>
      <ModalBody p={0}>{content}</ModalBody>
      <ModalFooter mt={6} p={0}>
        <Flex direction='row' gap={3} justifyContent='flex-end'>
          <Button mr={0} onClick={onClose} variant='secondary'>
            Cancel
          </Button>
          <Button mr={0} onClick={onSelectAnotherIncident} variant='secondary'>
            Select Another Incident
          </Button>
          {onRetry && <Button onClick={onRetry}>Retry</Button>}
        </Flex>
      </ModalFooter>
    </>
  )
}
